import { useMemo } from 'react';
import MoreOptionsMenu from '@sdk/components/ui/MoreOptionsMenu';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { MoreOptionsMenuOption } from '@sdk/components/ui/moreOptionsMenu.types';
import { TimesheetStatus } from '@sdk/timesheets/api/apiTypes';
import useAuth from '@sdk/authentication/useAuth';

import { FooterMoreActionsOptions } from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalFooter/TimesheetViewModalManagerFooter/timesheetViewModalManagerFooter.types';
import { getMoreButtonOptions } from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalFooter/TimesheetViewModalManagerFooter/MoreTimesheetFooterButton/moreTimesheetFooterButton.utils';

type Props = {
  onApprove: () => Promise<void>;
  onEdit: VoidFunction;
  onMarkPending: () => Promise<void>;
  timesheetStatus: TimesheetStatus;
  shouldHideEdit: boolean;
};
const MoreTimesheetFooterButton = ({
  onApprove,
  onEdit,
  onMarkPending,
  timesheetStatus,
  shouldHideEdit,
}: Props) => {
  const { currentUser } = useAuth();

  const moreButtonOptions = useMemo(
    () => getMoreButtonOptions({ timesheetStatus, shouldHideEdit, isAdmin: currentUser.isAdmin }),
    [timesheetStatus, shouldHideEdit, currentUser.isAdmin]
  );

  if (!moreButtonOptions.length) {
    return null;
  }

  const handleOptionClick = (option: MoreOptionsMenuOption) => {
    if (option.disabled) {
      return;
    }

    if (option.value === FooterMoreActionsOptions.approve) {
      onApprove();
    }

    if (option.value === FooterMoreActionsOptions.edit) {
      onEdit();
    }

    if (option.value === FooterMoreActionsOptions.markPending) {
      onMarkPending();
    }
  };

  return (
    <MoreOptionsMenu
      options={moreButtonOptions}
      onClick={handleOptionClick}
      borderThemeColor={ThemeColorType.separatorOnGray}
      baseOpacity={1}
    />
  );
};

export default MoreTimesheetFooterButton;
